import styled from "styled-components";

interface ICardProps {
  padding?: boolean;
}

const Card = styled.div<ICardProps>`
  position: relative;
  border-radius: ${props => props.theme.sizes.normal}rem;
  background-color: ${props => props.theme.colors.background};
  padding: ${props => (props.padding ? props.theme.sizes.large + "rem" : "0")};
  box-shadow: 0 ${props => props.theme.sizes.small}rem
    ${props => props.theme.sizes.normal}rem rgba(0, 0, 0, 0.1);
  ${props => (props.theme.isDark ? `border: 2px solid #222` : null)};
  margin-bottom: ${props => props.theme.sizes.large}rem;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  padding: ${props => props.theme.sizes.small}rem
    ${props => props.theme.sizes.large}rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2.5rem;
  background-color: ${props => props.theme.grayscale.g10};
`;
export const CardFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: ${props => props.theme.sizes.small}rem
    ${props => props.theme.sizes.large}rem;
  height: 2.5rem;
  background-color: ${props => props.theme.grayscale.g10};

  button {
    padding: 0.25rem 0.5rem;
    height: auto;
    font-size: 0.75rem;
  }
`;
export const CardBody = styled.div`
  padding: ${props => props.theme.sizes.large}rem;
`;

export default Card;
